import { parseNum } from './inventarioCalculos';

/** Campos del detalle de líneas que pueden originar una nueva versión al emitir Excel. */
const DETALLE_LINEA_KEYS = [
  'id_inventario_linea',
  'id_proforma',
  'correlativo_contenedor',
  'paquetes',
  'pcs_paq',
  'peso_mercaderia',
  'espesor',
  'ancho',
  'largo',
  'castigo_rw',
  'total_m3',
  'espesor_ganancia',
  'ancho_ganancia',
  'largo_ganancia',
  'castigo_rw_ganancia',
  'total_m3_ganancia',
  'precio_usd_m3',
];

function valorDetalleComparable(v) {
  if (v == null || v === '') return '';
  const n = parseNum(v);
  if (n != null && !Number.isNaN(n)) return String(n);
  return String(v).trim();
}

export function normalizarLineaDetallePacking(ln) {
  const out = {};
  for (const key of DETALLE_LINEA_KEYS) {
    const v = valorDetalleComparable(ln?.[key]);
    if (v !== '') out[key] = v;
  }
  return out;
}

export function snapshotDetalleLineasPacking(lineas) {
  return (lineas || [])
    .map(normalizarLineaDetallePacking)
    .sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));
}

/** `draft_label` y otros metadatos de draft no cuentan como cambio de versión. */
export function detalleLineasPackingModificado(inicial, actual) {
  if (!inicial && !(actual || []).length) return false;
  if (!inicial) return (actual || []).length > 0;
  return (
    JSON.stringify(snapshotDetalleLineasPacking(inicial)) !==
    JSON.stringify(snapshotDetalleLineasPacking(actual))
  );
}
